import React from 'react';
import HeroSection from '../components/HeroSection/HeroSection';
import Solutions from '../components/Solutions/Solutions';
import Clients from '../components/Clients/Clients';

const HomePage: React.FC = () => {
  return (
    <>
      <HeroSection />
      <Solutions />
      <Clients />
    </>
  );
};

export default HomePage;







